import ExpandIcon from '@squareup/dex-icons/dex/arrow/UpDownLeftRight';
import { IconButton } from '@squareup/dex-ui';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import React, { FC } from 'react';

import styles from './api-explorer-field-helpers.module.css';

const strings = {
  expandButtonLabel: 'Expand "{propertyName}" field',
};

interface Props {
  onClick: () => void;
  labelName: string;
}

const iconDim = 16;

const ExpandButton: FC<Props> = ({ labelName, onClick }) => {
  const label = strings.expandButtonLabel.replace('{propertyName}', labelName);

  return (
    <IconButton
      testId="api-explorer-field-expand-button"
      colorVariant="20"
      aria-label={label}
      containerClassName={styles['expand-button']}
      width={iconDim}
      height={iconDim}
      tooltipText={label}
      icon={
        <ExpandIcon className={commonIconStyles['icon-fill-current-color']} />
      }
      trackingId="property-info-expand-button"
      onClick={onClick}
    />
  );
};

export { ExpandButton };
